import { render, staticRenderFns } from "./CounterDisplay.vue?vue&type=template&id=48044016&scoped=true&"
import script from "./CounterDisplay.vue?vue&type=script&lang=js&"
export * from "./CounterDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48044016",
  null
  
)

component.options.__file = "CounterDisplay.vue"
export default component.exports